import { RhinoEPGProgram } from '@kaltura-ott/tvpil-shared';

import { epgLocalTimeStampStorage } from 'components/pages/Epg/storages';

export const filterVisiblePrograms = (programs: RhinoEPGProgram[]) => {
  const startScreenTime = epgLocalTimeStampStorage.getStartDate();
  const endScreenTime = epgLocalTimeStampStorage.getEndDate();

  return programs.filter((program) => program.endDate >= (startScreenTime) && program.startDate <= endScreenTime);
};
